import { type FC } from 'react';
import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import { type ReferralIncomeItemProps } from '@common/types/modal';
import { StringSmall } from '@components/Typography/Typography';
import cn from 'classnames';

import css from './styles.module.scss';

const AccountLevelRowData: FC<ReferralIncomeItemProps> = ({
  level,
  telegram,
  telegramPremium,
}) => {
  return (
    <div className={cn('py-2', css.columnTemplate)}>
      <StringSmall weight="regular" className="ml-3">
        {level}
      </StringSmall>
      {Array.from({ length: 2 }).map((_, index) => {
        const data = index === 0 ? telegram : telegramPremium;

        return (
          <div className="w-full flex gap-4 justify-end" key={index}>
            <StringSmall weight="regular">
              {toShortNumFormat(data.cash)}
            </StringSmall>
            <StringSmall weight="regular" className="mr-3 text-right min-w-8">
              {typeof data.tgem === 'number' ? data.tgem : 0}
            </StringSmall>
          </div>
        );
      })}
    </div>
  );
};

export { AccountLevelRowData };
